<header class="header-page">
  <h1 class="header__page__content__title">
    Informe de Rendimentos
  </h1>
</header>

<ng-container #showLoading>
  <spinner [show]="loading"></spinner>
</ng-container>


<main class="col-sm-12 col-xl-12 main__content">
  <section class="content__header" *ngIf="incomes && incomes.length > 0">
    <h2>
      Meus Informes
    </h2>
    <filtro-dados [pageItens]="5" [totalItens]="tamanhoLista" (changeQuantidade)="onChangeQuantidadeItens($event)">
    </filtro-dados>
  </section>
  <ng-template #notShowInformes>
    <ng-container *ngIf="!loading">
      <div class="informacao-no-refunds my-2">
        <div class="col-md-12 text-initial">
          <b>Informações disponíveis para os ativos no Informe de Rendimentos {{date}}</b>
          <section>
            O informe de rendimentos {{date}} estará disponível somente para os participantes ativos que apresentem
            pelo menos uma das situações abaixo:
            <br>
            <ul>
              <li>Aportes de contribuições previdenciárias (pagamento realizado em boleto);</li>
              <li>Situação de empréstimo;</li>
              <li>Rendimentos tributáveis de reembolso de medicamentos e despesas efetuadas fora da rede credenciada,
                cujo reembolso foi à vista.</li>
              <li>Caso o participante não apresente nenhuma das situações acima, não existirá Informe de Rendimentos
                {{date}}.</li>
            </ul>
          </section>
          <b>Despesas dedutíveis de saúde</b>
          <p>
            As despesas dedutíveis de saúde - como mensalidades e coparticipações - não estão presentes nos
            comprovantes dos participantes ativos disponibilizados pela Fundação Copel.
            Esta informação está no comprovante de rendimentos das patrocinadoras.
          </p>
          <b>Informações disponíveis para os aposentados</b>
          <p>
            Para os aposentados, todas as informações estão disponíveis no Informe de Rendimentos disponibilizado pela
            Fundação Copel.
          </p>
        </div>
      </div>
            
    </ng-container>
  </ng-template>
  <section class="content__main" *ngIf="incomes && incomes.length > 0 ; else notShowInformes">
    <div class="d-flex content__header__table">
      <div class="col-xl-9">Ano</div>
      <div class="col-xl-3">Ações</div>
    </div>
    <div class="table__card" *ngFor="let item of getItensDaPagina()">
      <div class="col-xl-9 table__card__title">
        Informe de Rendimento - {{ item.year }}
      </div>
      <div class="col-xl-3 table__card__button__action">
        <fa-icon [icon]="faPrint" (click)="download(item)"></fa-icon>
      </div>
    </div>
  </section>
</main>


<footer class="col-12 footer__content" *ngIf="incomes && incomes.length > 0">
  <ngb-pagination [collectionSize]="incomes.length" [(page)]="paginaAtual" [pageSize]="itensPorPagina"
    [maxSize]="2"></ngb-pagination>
</footer>